import(/* webpackMode: "eager" */ "/app/src/app/ai-scans/page.tsx");
